module.exports = __webpack_public_path__ + "img/ic_edit_1.ad45e3eb.svg";